<template>
  <div class="index">
    <div class="errbg">
      <div class="textbox">
        <p class="errp">哎呀，这个页面不见了...</p>
        <p class="msgp">可能原因：网络信号差、网址输入错误、该页面被移动或删除</p>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {};
  },
  components: {}
};
</script>

<style lang="scss" scoped>
*{
  margin:0;
  padding:0;
}
.errbg {
  height: 100vh;
  color: #ffffff;
  background-color: #f1b79e;
  text-align: center;
  position: relative;
}
.textbox{
  text-align: center;
  position: absolute;
  bottom: 268px;
  left:-50%;
  right:-50%;
}
.errp {
  font-size: 20px;
  margin-top:37px;
}
.msgp {
  font-size: 8px;
  // padding-top: 390px;
}
</style>
